import api from './../api';
import {i18n} from '../../main';

export default {
  namespaced: true,
  state: {
    item: {},
  },
  getters: {
    itemPermission(state) {
      return function (aclId, type) {
        if (state.item.userAcl === undefined) {
          return false;
        }
        const found = state.item.userAcl.find(function (item) {
          return item.acl.id === aclId;
        });
        return found !== undefined && found.value.includes(type);
      }
    },
  },
  actions: {
    list(store, params) {
      return new Promise((resolve, reject) => {
        api.post('user/list/' + params.page, params).then(response => {
          resolve(response.data);
        }).catch(error => {
          reject(error.response);
        });
      });
    },
    get(store, id) {
      return new Promise((resolve, reject) => {
        api.get('user/' + id).then(response => {
          store.commit('setItem', response.data);
          resolve(response.data);
        }).catch(error => {
          reject(error.response);
        });
      });
    },
    remove(store, id) {
      return new Promise((resolve, reject) => {
        api.delete('user/' + id).then(response => {
          store.commit('resetItem');
          resolve();
        }).catch(error => {
          // todo: catch error
          reject(error.response);
        });
      });
    },
    create(store, params) {
      return new Promise((resolve, reject) => {
        api.post('user', params).then(response => {
          if (response.data.hasOwnProperty('valid') && response.data.valid === false) {
            reject(response.data.status);
            let text = i18n.t(response.data.status);
            if (text.includes('{email}')) {
              text = text.replace('{email}', response.data.email);
            }
            if (text.includes('{cellphone}')) {
              text = text.replace('{cellphone}', response.data.cellphone);
            }
            store.dispatch('alert/error', text, {root: true});
          } else {
            store.commit('setItem', response.data);
            resolve(response.data);
          }
        }).catch(error => {
          reject(error.response);
        });
      });
    },
    update(store, params) {
      return new Promise((resolve, reject) => {
        api.put('user/' + params.id, params).then(response => {
          store.commit('setItem', response.data);
          resolve(response.data);
        }).catch(error => {
          reject(error.response);
        });
      });
    },
    changePassword(store, params) {
      return new Promise((resolve, reject) => {
        api.put('user/change-password/' + params.id, params).then(response => {
          resolve(response.data);
        }).catch(error => {
          reject(error.response);
        });
      });
    },
  },
  mutations: {
    setProfile(state, data) {
      state.user = data;
    },
    setItem(state, data) {
      state.item = data;
    },
    resetItem(state) {
      state.item = {
        blocked: false,
      };
    },
    changePermission(state, data) {
      let found = state.item.userAcl.find((item) => item.acl.id === data.item.id);
      if (found !== undefined) {
        if (data.value === true) {
          found.value += data.type;
        } else {
          found.value = found.value.replace(data.type, '');
          if (found.value === '') {
            const foundIndex = state.item.userAcl.findIndex((item) => item.acl.id === data.item.id);
            state.item.userAcl.splice(foundIndex, 1);
          }
        }
      } else {
        state.item.userAcl.push({
          value: data.type,
          acl: data.item
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js